import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { authActionPublic } from '../store/auth';

//TOASTER
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//COMPONENTS
import Error404 from '../pages/error404';
import Painel from '../pages/painel';

class PublicLayout extends React.PureComponent
{
    constructor(props)
    {
        super(props);

        document.body.style = 'background: #01bc8e;';
    }

    render()
    {
        const auth = this.props.auth;

        if (auth.isLoading === false && auth.isAuthenticated === true) return ( <Painel /> );

        return (
            <div className="container">
                
                <ToastContainer newestOnTop hideProgressBar autoClose={2000} transition={Slide} toastClassName="toast" />

                <img src="/assets/images/bg-wave.png" style={{"height": "100vh", "position": "absolute", "bottom": "0px", "right": "0px"}} />

                <div className="loginColumns animated fadeInDown h-100" style={{"maxWidth": "1176px", "padding": "50px 20px 0px 20px"}}>
                    <div className="row h-100">
                        <div className="col-md-6 container">
                            <div className="row h-100 justify-content-center align-items-center">            
                                
                                {this.props.children}

                            </div>
                        </div>

                        <div className="col-md-6 container">
                            <div className="row h-100 justify-content-center align-items-center mb-5 pb-5">           
                                <div>
                                    <img src="/assets/images/img-login.png" style={{"height": "559px"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>        
            </div>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicLayout));
